import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fcec90e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-box" }
const _hoisted_2 = { class: "center-inner" }

import { reactive,getCurrentInstance,onMounted } from "vue";
import {onBeforeRouteUpdate} from "vue-router";
import pageHead from "@/components/pageHead/index.vue"
import pageFooter from "@/components/pageFooter/index.vue"
import centerMenu from "@/views/center/components/centerMenu/index.vue"
import centerApp from "@/views/center/components/centerApp/index.vue"
import pullRefresh from "@/components/pullRefresh/index.vue";
import pullRefreshJs from "@/components/pullRefresh/index.js"//pullRefresh組件列表懶加載
import store from "@/store";

export default {
  __name: 'index',
  setup(__props) {

const { proxy } = getCurrentInstance()
const Util = proxy.$Util
store.dispatch("getInfoDataAction",{})
const data = reactive({
  CONFIG:proxy.$CONFIG,
  Router:proxy.$Router,
  pageHeight:"",
  transitionName:"",
  routerInfo:proxy.$Router.info(),
  centerContentHeight:"",
  // valid: true,//pullRefresh組件列表懶加載
})
// window.addEventListener('scroll', this.setTimer);//pullRefresh組件列表懶加載
// const setTimer=()=>{//pullRefresh組件列表懶加載
//   if(!data.valid){
//     return false
//   }
//   data.valid = false
//   setTimeout(() => {
//     getMore()
//     data.valid = true;
//   }, 500)
// }
// const getMore=()=> {//pullRefresh組件列表懶加載
//   return pullRefreshJs.getMoreOfScroll(getDataList)
// }
// const getDataList=()=> {//pullRefresh組件列表懶加載
//   //ajax请求方法
// }
const setAppHeight = ()=>{
  if(window.innerWidth>767)return
  data.pageHeight = window.innerHeight+'px'//获取当前可视区域的高度存到hrt变量
}
setAppHeight()
const setCenterAppHeight = ()=>{
  data.centerContentHeight = $(".center-menu")[0].offsetHeight+'px'
  if(window.innerWidth<=767){
    data.centerContentHeight="unset"
  }
}
// const pullDownRefresh = (done)=>{
//   window.location.reload();
//   done()
// }
onMounted(()=>{
  setCenterAppHeight()
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(pullRefresh, {
    onRefresh: _unref(pullRefreshJs).pullDownRefresh
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "center scroll-page",
        style: _normalizeStyle((data.pageHeight!==''?('height:'+data.pageHeight):''))
      }, [
        _createVNode(pageHead),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(centerMenu),
            _createElementVNode("div", {
              class: "center-content",
              style: _normalizeStyle((data.centerContentHeight!==''?('height:'+data.centerContentHeight):''))
            }, [
              _createVNode(centerApp)
            ], 4)
          ])
        ]),
        _createVNode(pageFooter)
      ], 4)
    ]),
    _: 1
  }, 8, ["onRefresh"]))
}
}

}